 
import CourseLandingPage from '../../components/Courses/CourseLandingPage/CourseLandingPage'
import SEO from '../../components/common/seo/SEO'
import nxOpenCourse from '../../data/cad_section/nxOpenCourse'

function NXOpenCoursePage() {
  return (
    <>
      <SEO
        title="NX Open Customization & Automation Training | NX Open .NET Course | FeesWorth"

        description="Learn Siemens NX Open customization and automation using C# and .NET. Master NX Open API, CAD automation, custom applications, feature automation, and practical NX Open projects with expert training at FeesWorth."

        keywords="NX Open Training, NX Open Customization Training, NX Open Automation Training, NX Open .NET Training, NX Open C# Training, Siemens NX Open Course, NX Open API Training, NX Customization Course, NX Automation Course, NX Open Programming"

        canonical="https://feesworth.com/nx-open-customization-automation-training"
      />

      <CourseLandingPage course={nxOpenCourse} />
    </>
  )
}

export default NXOpenCoursePage